import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "col-xl-auto" }
const _hoisted_3 = ["disabled", "title"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col-xl" }
const _hoisted_7 = { class: "row g-3" }
const _hoisted_8 = { class: "form-control-plaintext" }
const _hoisted_9 = { class: "form-control-plaintext" }
const _hoisted_10 = {
  class: /*#__PURE__*/_normalizeClass(`col-form-label col-xl-6-em col-7-em`)
}
const _hoisted_11 = { class: "form-control-plaintext" }
const _hoisted_12 = { class: "col-xl-auto" }
const _hoisted_13 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-pdf me-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!
  const _component_FormGridMember = _resolveComponent("FormGridMember")!
  const _component_ReviewFileWidget = _resolveComponent("ReviewFileWidget")!
  const _component_JobDownloadButton = _resolveComponent("JobDownloadButton")!
  const _component_FormGridLocal = _resolveComponent("FormGridLocal")!
  const _directive_popover = _resolveDirective("popover")!

  return (_openBlock(), _createBlock(_component_FormGridLocal, {
    labelWidth: 7,
    verticalBreakpoint: "sm"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("button", {
            type: "button",
            disabled: this.disabled,
            class: "btn btn-outline-secondary",
            title: _ctx.$t('review.review.header.infoTitle'),
            "data-bs-toggle": "popover",
            "data-bs-html": "true"
          }, _hoisted_5, 8, _hoisted_3), [
            [_directive_popover, { content: () => this.infoPopupContent, allowList: { ..._ctx.Tooltip.Default.allowList, dl: [], dt: [], dd: [] } }]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_FormGridMember, { class: "col-xl-5" }, {
              label: _withCtx(({ class: clazz }) => [
                _createElementVNode("div", {
                  class: _normalizeClass(`col-form-label ${clazz}`)
                }, _toDisplayString(_ctx.$t('general.titleContent')), 3)
              ]),
              control: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.context }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$s(this.content)), 1)
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_FormGridMember, { class: "col-xl-4" }, {
              label: _withCtx(({ class: clazz }) => [
                _createElementVNode("div", {
                  class: _normalizeClass(`col-form-label ${clazz}`)
                }, _toDisplayString(_ctx.$t('general.planNumber')), 3)
              ]),
              control: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.context }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.context.baseJoin.documentVersionName), 1)
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_FormGridMember, { class: "col-xl-3" }, {
              label: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('general.scale')), 1)
              ]),
              control: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.context }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(this.scale), 1)
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_ReviewFileWidget, {
              disabled: this.disabled,
              context: _ctx.context,
              documentVersionId: _ctx.documentVersionId
            }, null, 8, ["disabled", "context", "documentVersionId"]),
            _createVNode(_component_JobDownloadButton, {
              disabled: this.disabled,
              startDownload: () => _ctx.startReviewProtocolDownload(),
              class: "btn btn-secondary"
            }, {
              icon: _withCtx(() => [
                _hoisted_14
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.$t('review.review.header.reviewProtocolPdf')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "startDownload"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}